module.exports = __webpack_public_path__ + "static/media/funitygame4.f774e06f.png";